var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5L38.8333 18.75L36.8333 21.4167L33.8333 19.1667V35H7.16663V19.1667L4.16663 21.4167L2.16663 18.75L20.5 5ZM12.75 20.0833C12.75 21.5556 13.5416 23.125 15.125 24.7917C16.7083 26.4583 18.5 28.1944 20.5 30C22.5 28.1944 24.2916 26.4583 25.875 24.7917C27.4583 23.125 28.25 21.5556 28.25 20.0833C28.25 18.8611 27.8333 17.8472 27 17.0417C26.1666 16.2361 25.1666 15.8333 24 15.8333C23.2777 15.8333 22.6177 15.9794 22.02 16.2717C21.4222 16.5639 20.9155 16.9456 20.5 17.4167C20.0833 16.9444 19.5627 16.5628 18.9383 16.2717C18.3138 15.9806 17.6677 15.8344 17 15.8333C15.8333 15.8333 14.8333 16.2361 14 17.0417C13.1666 17.8472 12.75 18.8611 12.75 20.0833Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.514aa913.svg";
export { ForwardRef as ReactComponent };